import theme from '@theme';
import styled from 'styled-components';

const ReportCardContainer = styled.div`
  width: 100%;
  height: 2.25rem;
  border-radius: 0.25rem;
  border: 1px solid ${theme.palette.grey[100]};
  background-color: white;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-top: 0.625rem;
`;

export default ReportCardContainer;
